/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-04-29",
    versionChannel: "nightly",
    buildDate: "2025-04-29T00:06:51.344Z",
    commitHash: "968102d7afb710c389ba72c2ca58427b0f84e876",
};
